export default __webpack_public_path__ + "static/media/ic_menu_leaveoff_staff.445093bb.svg";